import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { Reveal } from '@/components/generals/reveal'
import { Accent, SectionHeading } from '@/components/landing/section-heading'

import { testimonials } from '@/constants/landing'

const avatarTones = [
    'bg-[radial-gradient(circle_at_32%_28%,#8d9bff,#2f49ff_60%,#1a2ab8)] text-white',
    'bg-[radial-gradient(circle_at_32%_28%,#ffffff,#e4e6ee_55%,#c4c8d6)] text-ink',
    'bg-[radial-gradient(circle_at_32%_28%,#5a5d6b,#17181f_60%,#050508)] text-white'
]

export const TestimonialsSection: FC = (): ReactNode => {
    return (
        <section id='testimonials' className='scroll-mt-20 border-t border-hairline py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <Reveal>
                    <SectionHeading
                        index="05"
                        label="Voices"
                        title={<>Loved in classrooms <Accent>and lecture halls.</Accent></>}
                        description="What teachers, students and lecturers from our early-access group say after a term with live simulations."
                    />
                </Reveal>

                <div className='mt-14 grid gap-4 md:grid-cols-3 lg:gap-5'>
                    {testimonials.map((testimonial, index) => (
                        <Reveal key={testimonial.name} delay={index * 110} className='h-full'>
                            <figure className='flex h-full flex-col justify-between rounded-[28px] border border-border/80 bg-white p-7 elevate sm:p-8'>
                                <blockquote className='font-serif text-[23px] leading-[1.32] tracking-[-0.005em] text-ink'>
                                    <span aria-hidden='true' className='mr-1 text-brand'>&ldquo;</span>
                                    {testimonial.quote}
                                    <span aria-hidden='true' className='ml-0.5 text-brand'>&rdquo;</span>
                                </blockquote>

                                <figcaption className='mt-10 flex items-center gap-3 border-t border-hairline pt-6'>
                                    <span
                                        aria-hidden='true'
                                        className={cn('flex size-10 items-center justify-center rounded-full text-xs font-semibold elevate', avatarTones[index % avatarTones.length])}
                                    >
                                        {testimonial.initials}
                                    </span>

                                    <span>
                                        <span className='block text-sm font-semibold text-ink'>{testimonial.name}</span>
                                        <span className='block text-[13px] text-muted-foreground'>{testimonial.role}</span>
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    )
}
